export default __webpack_public_path__ + "static/media/como-reward.86385561.png";